"use strict";

import "~/polyfill";

import { CONSTANTS } from "~/helpers/constants";

import { api } from "~/services/api";

import { getCookiedockCuuid, logCookiedockError } from "~/helpers";
import { activateCategory, addListeners } from "~/block/listeners";
import { removeRejectedCookies, removeAllCookiesWithoutConsent, storeContentData, applyPersistedConsent, saveConsentState } from "~/block/cookie";

// import { initScriptBlocker } from "~/block/script";
// import { initEventBlocker, overrideWindowMethods } from "~/block/event";

import type { Cookiedock } from "~/types";

export const cuuid = getCookiedockCuuid(CONSTANTS.DEFAULT.DATASET_NAME);

export async function __init() {
  window.cookiedock.__activateCategory = activateCategory;

  if (!window.cookiedock.__consent) {
    window.cookiedock.__consent = {
      unknown: true,
    };
  }

  const hasAppliedConsent = applyPersistedConsent();

  if (hasAppliedConsent) {
    runBlockers();

    Object.keys(window.cookiedock.__consent).forEach((category) => {
      if (window.cookiedock.__consent[category] === true) {
        activateCategory(category);
      }
    });
    return;
  }

  if (!cuuid) {
    logCookiedockError(CONSTANTS.CONSOLE.NO_CUUID_FOUND);
    return;
  }

  const cookieData = await api.get<Cookiedock>(`api/v1/${cuuid}/consent`);
  if (!cookieData) {
    logCookiedockError(CONSTANTS.CONSOLE.UNABLE_TO_FETCH_CONSENT);
    return;
  }

  window.cookiedock.__mock = cookieData.content?.appearance?.mock === true;

  if (!window.cookiedock.__mock) {
    runBlockers();

    if (cookieData.cookie_purposes && cookieData.cookie_purposes.length === 0) {
      logCookiedockError(CONSTANTS.CONSOLE.NO_COOKIE_PURPOSES);
      return;
    }

    window.cookiedock.__cookie_purposes = cookieData.cookie_purposes;

    storeContentData(cookieData.content);
    removeAllCookiesWithoutConsent(cookieData.cookie_purposes);
  }

  await addListeners(cookieData);
}

/**
 * Initialize all blockers (events, scripts, window methods)
 */
function runBlockers() {
  setInterval(removeRejectedCookies, CONSTANTS.TTL.TENMINUTES * 10);

  // initScriptBlocker();
  // initEventBlocker();
  // overrideWindowMethods();
}

/** Init */
(async () => {
  try {
    await __init();
  } catch (error) {
    console.error("Cookiedock initialization failed:", error);
  }
})();
